import api from '../../api';

const state = {
  currencies: [],
  conversionRates: {},
};

const getters = {
  currencies(state) {
    return state.currencies;
  },
  conversionRates(state) {
    return state.conversionRates;
  },
  currentConversionRate(state) {
    return id => {
      if (state.conversionRates[id]) {
        return state.conversionRates[id][0];
      } else {
        throw new Error('conversion rate does not exist');
      }
    };
  },
  firstConversionRate(state){
    return id => {
      if (state.conversionRates[id]) {
        return state.conversionRates[id][0];
      } else {
        throw new Error('conversion rate does not exist');
      }
    };
  },
  conversionRatesById(state) {
    return id => {
      return state.conversionRates[id];
    };
  },
  currencyById(state) {
    return id => {
      return state.currencies.find(curr => curr.id === id);
    };
  },
  currencyCodeById(state) {
    return id => {
      let curr = state.currencies.find(curr => curr.id === id);
      return curr ? curr.code : '';
    };
  },
};

const mutations = {
  setCurrencies(state, payload) {
    state.currencies = payload;
  },
  setConversionRates(state, payload) {
    state.conversionRates = payload;
  },
};

const actions = {
  setCurrencies(context, payload) {
    context.commit('setCurrencies', payload);
  },
  setConversionRates(context, payload) {
    context.commit('setConversionRates', payload);
  },
  getCurrencies(context) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await api.getAllCurrencies();
        context.dispatch('setCurrencies', data.currencies);
        context.dispatch('setConversionRates', data.conversionRates);
        resolve();
      } catch (e) {
        console.error(e);
        reject(e);
      }
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
